module.exports = __webpack_public_path__ + "media/images/icons/supervisor-edf52e8005b0255d64d39f94ffd560bd.svg";